export default {
    en: {
        subject: 'Payment for booking',
        content: {
            payment_title: 'Payment Method',
            payment_link: 'Payment Link',
            price_original: 'Current price',
            price_difference: 'Price difference',
            price_total: 'New price',
            transaction_costs: 'Transaction costs',
        },
    },
    de: {
        subject: 'Zahlungslink',
        content: {
            payment_title: 'Zahlungsmethode',
            payment_link: 'Zahlungslink',
            price_original: 'Derzeitiger Preis',
            price_difference: 'Unterschied',
            price_total: 'Neuer Preis',
            transaction_costs: 'Transaktionskosten',
        },
    },
    es: {
        subject: 'Enlace de Pago',
        content: {
            payment_title: 'Método de Pago',
            payment_link: 'Enlace de Pago',
            price_original: 'Current price',
            price_difference: 'Precio Actual',
            price_total: 'Nuevo Precio',
            transaction_costs: 'Costos de Transacción',
        },
    },
    fr: {
        subject: 'Lien de Paiement',
        content: {
            payment_title: 'Mode de Paiement',
            payment_link: 'Lien de Paiement',
            price_original: 'Prix Actuel',
            price_difference: 'Différence',
            price_total: 'Nouveau Prix',
            transaction_costs: 'Coûts de Transaction',
        },
    },
    it: {
        subject: 'Collegamento di Pagamento',
        content: {
            payment_title: 'Metodo di Pagamento',
            payment_link: 'Link di Pagamento',
            price_original: 'Prezzo Attuale',
            price_difference: 'Differenza',
            price_total: 'Nuovo Prezzo',
            transaction_costs: 'Costi di Transazione',
        },
    },
    nl: {
        subject: 'Betaallink',
        content: {
            payment_title: 'Betaalmethode',
            payment_link: 'Payment Link',
            price_original: 'Huidige prijs',
            price_difference: 'Verschil',
            price_total: 'Nieuwe prijs',
            transaction_costs: 'Transactie kosten',
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/transaction/paymentLink/mailto/localisation.js